export var USER_AUTH_KEY = '_baas_ua';
export var REFRESH_TOKEN_KEY = '_baas_rt';
export var USER_AUTH_COOKIE_NAME = 'baas_ua';
export var DEFAULT_ACCESS_TOKEN_EXPIRE_WITHIN_SECS = 10;
//# sourceMappingURL=Common.js.map